import { render, staticRenderFns } from "./PriceCalculator.vue?vue&type=template&id=3937c270&scoped=true"
import script from "./PriceCalculator.vue?vue&type=script&lang=js"
export * from "./PriceCalculator.vue?vue&type=script&lang=js"
import style0 from "./PriceCalculator.vue?vue&type=style&index=0&id=3937c270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937c270",
  null
  
)

export default component.exports